import { AxiosError } from 'axios'
import { redirect } from 'react-router-dom'

import { persistChatIdToOpenToLocalStorage, persistChatModalOpenToLocalStorage, persistUrlDataToLocalStorage } from './utils'

const isAxiosError = (error: unknown | AxiosError): error is AxiosError => {
  return !!(error as AxiosError)?.response?.status
}

const apiErrorHandler = (error: unknown | AxiosError): void => {
  if (isAxiosError(error) && error?.response?.status === 401) {
    if (window.location.pathname !== '/sign-in') {
      if (window.location.pathname !== '/') {
        persistUrlDataToLocalStorage()
      }

      if (window.location.search?.includes('chat-modal-open')) {
        persistChatModalOpenToLocalStorage()
      }

      if (window.location.search?.includes('chat-id-to-open')) {
        const splittedSearch = window.location.search.split('=')
        if (splittedSearch[1]) {
          persistChatIdToOpenToLocalStorage(splittedSearch[1])
        }
      }

      redirect('/sign-in')
      window.location.reload()
    }

    return
  }

  throw error
}

export default apiErrorHandler
